import Button from '@components/Button/Button';
import type { EmailSignatureV2 } from '@components/EmailSignaturev2/types';
import Input from '@components/Input/Input';
import { useRouter } from 'next/router';
import { type FC, useState } from 'react';

import {
  MobileOnboardingInputsGroup,
  MobileOnboardingInputsSection,
  MobileOnboardingInputsSectionHeader,
  MobileOnboardingInputsSectionHeaderContainer,
  MobileOnboardingNextButtonContainer,
} from './MobileOnboardingInputs';
import { type CommonOnboardingDetailsPageForMobileProps, MobileDetailsSteps } from './types';

type OnboardingOccupationDetailsPageForMobileProps = Omit<
  CommonOnboardingDetailsPageForMobileProps,
  'uploadEmailSignatureFieldImagesThunk' | 'handleErrorUploadingImage'
>;

const OnboardingOccupationDetailsPageForMobile: FC<
  React.PropsWithChildren<OnboardingOccupationDetailsPageForMobileProps>
> = ({ emailSignature, emailSignatureDispatch, handleSave }) => {
  const router = useRouter();
  const [isSaving, setIsSaving] = useState<boolean>(false);

  function onJobTitleChange(updatedJobTitle: string) {
    emailSignatureDispatch({ type: 'UPDATE_JOB_TITLE', value: updatedJobTitle });
  }

  function onCompanyNameChange(updatedCompanyName: string) {
    emailSignatureDispatch({ type: 'UPDATE_COMPANY', value: updatedCompanyName });
  }

  async function onClickNext() {
    setIsSaving(true);
    await handleSave(emailSignature, (savedEmailSignature: EmailSignatureV2) => {
      router.push(`/onboarding/email-signature/details/${MobileDetailsSteps.CONTACT_DETAILS}`, undefined, {
        shallow: true,
      });
      setIsSaving(false);
      emailSignatureDispatch({ type: 'IMPORT_EMAIL_SIGNATURE', value: savedEmailSignature });
    });
  }

  return (
    <MobileOnboardingInputsSection>
      <MobileOnboardingInputsSectionHeaderContainer>
        <MobileOnboardingInputsSectionHeader>What is your occupation?</MobileOnboardingInputsSectionHeader>
      </MobileOnboardingInputsSectionHeaderContainer>

      <MobileOnboardingInputsGroup>
        <Input
          label="Job title"
          type="text"
          value={emailSignature.personalDetails.jobTitle}
          onChange={onJobTitleChange}
          autoComplete="organization-title"
          enableClearButton
        />

        <Input
          label="Company name"
          type="text"
          value={emailSignature.personalDetails.company}
          onChange={onCompanyNameChange}
          autoComplete="organization"
          enableClearButton
        />
      </MobileOnboardingInputsGroup>
      <MobileOnboardingNextButtonContainer>
        <Button size="large" onClick={onClickNext} loading={isSaving}>
          Next
        </Button>
      </MobileOnboardingNextButtonContainer>
    </MobileOnboardingInputsSection>
  );
};

export default OnboardingOccupationDetailsPageForMobile;
